import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import React from "react"

import { useTranslation } from "../../../../i18n/translate"
import PDFIcon from "../../../../images/file-icons/pdf.svg"
import { DownloadModel } from "../../../../model/downloadModel"
import { FileModel } from "../../../../model/fileModel"
import ContextMenu from "../../../context-menu/context-menu"
import "./file-download.sass"

const classnames = require("classnames")
const prettyBytes = require("pretty-bytes")

const FileDownload = ({
  fileStyle,
  downloadGroup,
  file,
  fullWidth,
  ...props
}) => {
  const { i18n, t } = useTranslation()

  const pdf_file = file || downloadGroup[0].pdf_file
  const description = file || downloadGroup[0].description

  const { fileName, fileSize, fileType } = pdf_file

  const prettyFileSize = fileSize
    ? prettyBytes(fileSize, { locale: i18n.language })
    : undefined

  const downloadFile = (url) => {
    window.open(url, "_blank")
  }

  const regions = {}
  if (!file && downloadGroup[0].availability_regions.length > 0) {
    // Group pdf_files by availability regions
    downloadGroup.forEach((download) => {
      download.availability_regions.forEach((availabilityRegion) => {
        if (!regions[availabilityRegion.name.key]) {
          regions[availabilityRegion.name.key] = []
        }
        regions[availabilityRegion.name.key].push(download.pdf_file)
      })
    })
    // create a new FileModel with all files of the region
    for (const regionsKey in regions) {
      regions[regionsKey] = new FileModel({
        ...regions[regionsKey][0],
        files: regions[regionsKey].reduce((accumulator, current) => {
          return [...accumulator, ...current.files]
        }, []),
      })
    }
  } else {
    regions["_internal_name_doesnt_matter"] = pdf_file
  }

  let options = Object.keys(regions)
    .sort((a, b) => t(a).localeCompare(t(b)))
    .map((regionKey) => {
      const { files } = regions[regionKey]
      return {
        label: regionKey,
        children: files
          .sort((a, b) =>
            t("GLOBAL-LANGUAGE-" + a.language).localeCompare(
              t("GLOBAL-LANGUAGE-" + b.language),
            ),
          )
          .map((file) => {
            return {
              label: "GLOBAL-LANGUAGE-" + file.language,
              callback: () => downloadFile(file.file.localFile.publicURL),
            }
          }),
      }
    })

  if (options.length === 1) {
    options = options[0].children
  }

  options.push(
    ...Object.values(regions)
      .map((file) => file.additionalLinks || [])
      .reduce((prev, curr) => [...prev, ...curr], []),
  )
  return (
    <ContextMenu options={options}>
      <div
        {...props}
        className={classnames(
          "_fp-file-download",
          { "_fp-file-download--white": fileStyle === "white" },
          { "_fp-file-download--full-width": fullWidth },
          { "_fp-file-download--gray": fileStyle === "gray" },
        )}
      >
        <div className={"_fp-file-download__main"}>
          <div className="_fp-file-download__main__icon">
            {downloadGroup &&
            downloadGroup.length > 0 &&
            downloadGroup[0].pdf_file?.files &&
            downloadGroup[0].pdf_file?.files.length > 0 &&
            downloadGroup[0].pdf_file.files[0].file?.localFile?.childScreenshot
              ?.screenshotFile?.childImageSharp?.gatsbyImageData ? (
              <GatsbyImage
                image={
                  downloadGroup[0].pdf_file.files[0].file.localFile
                    .childScreenshot.screenshotFile.childImageSharp
                    .gatsbyImageData
                }
                alt={""}
              />
            ) : (
              <PDFIcon />
            )}
          </div>
          <div className="_fp-file-download__main__content">
            {fileName && (
              <p
                className={
                  "_fp-heading-6 _fp-file-download__main__content__file-name"
                }
              >
                {t(fileName.key)}
              </p>
            )}
            <p
              className={
                "_fp-file-download__main__content__info _fp-text _fp-text--small"
              }
            >
              {prettyFileSize && <span>{prettyFileSize}</span>}
            </p>

            {description.key && (
              <p
                className={
                  "_fp-text _fp-text--small-dark _fp-file-download__file-description"
                }
              >
                {t(description.key)}
              </p>
            )}
          </div>
        </div>
      </div>
    </ContextMenu>
  )
}

FileDownload.propTypes = {
  fileStyle: PropTypes.oneOf(["white", "gray"]),
  downloadGroup: PropTypes.arrayOf(PropTypes.instanceOf(DownloadModel)),
  file: PropTypes.instanceOf(FileModel),
  fullWidth: PropTypes.bool,
}

FileDownload.defaultProps = {
  fileStyle: "gray",
}

export default FileDownload
